import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function GallerySection() {
  const { t } = useTranslation();
  const [lightbox, setLightbox] = useState<string | null>(null);

  const images = [
    {
      src: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20interior%20with%20wooden%20beams%2C%20soft%20neutral%20sofa%2C%20warm%20natural%20light%20from%20large%20windows%2C%20potted%20plants%2C%20natural%20beige%20and%20green%20tones%2C%20editorial%20interior%20photography%2C%20high%20detail%2C%20serene%20atmosphere&width=800&height=600&seq=gallery-wohnzimmer-01&orientation=landscape',
      alt: t('gallery.altLiving'),
      span: 'md:col-span-2 md:row-span-2',
      height: 'h-[300px] md:h-full',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Modern%20open%20kitchen%20interior%20with%20light%20wood%20cabinets%2C%20white%20countertops%2C%20stainless%20appliances%2C%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20clean%20minimalist%20design%2C%20high%20detail&width=800&height=600&seq=gallery-kueche-01&orientation=landscape',
      alt: t('gallery.altKitchen'),
      span: '',
      height: 'h-[200px] md:h-[230px]',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Bright%20bedroom%20interior%20with%20white%20linen%20bedding%2C%20large%20window%20with%20natural%20light%2C%20wooden%20nightstand%2C%20soft%20neutral%20decor%2C%20warm%20beige%20and%20cream%20tones%2C%20editorial%20photography%2C%20peaceful%20atmosphere%2C%20high%20detail&width=800&height=600&seq=gallery-schlafzimmer-01&orientation=landscape',
      alt: t('gallery.altBedroom'),
      span: '',
      height: 'h-[200px] md:h-[230px]',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Modern%20bathroom%20interior%20with%20light%20tiles%2C%20large%20mirror%2C%20wooden%20vanity%2C%20natural%20daylight%2C%20clean%20minimalist%20design%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20spa-like%20atmosphere%2C%20high%20detail&width=800&height=600&seq=gallery-bad-01&orientation=landscape',
      alt: t('gallery.altBathroom'),
      span: '',
      height: 'h-[200px] md:h-[230px]',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=North%20sea%20beach%20with%20wooden%20groynes%2C%20golden%20sand%2C%20blue%20sky%20with%20soft%20clouds%2C%20gentle%20waves%2C%20warm%20natural%20light%2C%20coastal%20landscape%20photography%2C%20serene%20atmosphere%2C%20high%20detail&width=800&height=600&seq=gallery-strand-01&orientation=landscape',
      alt: t('gallery.altBeach'),
      span: 'md:col-span-2',
      height: 'h-[200px] md:h-[230px]',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=North%20sea%20dike%20landscape%20with%20green%20meadows%2C%20cycling%20path%2C%20sheep%20grazing%20in%20distance%2C%20wide%20blue%20sky%2C%20warm%20natural%20beige%20and%20green%20tones%2C%20editorial%20landscape%20photography%2C%20high%20detail%2C%20serene%20atmosphere&width=800&height=600&seq=gallery-deich-01&orientation=landscape',
      alt: t('gallery.altDike'),
      span: '',
      height: 'h-[200px] md:h-[230px]',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Small%20coastal%20harbor%20with%20traditional%20boats%2C%20thatched%20roof%20houses%20in%20background%2C%20calm%20water%20reflection%2C%20warm%20afternoon%20light%2C%20natural%20beige%20and%20green%20tones%2C%20editorial%20photography%2C%20idyllic%20atmosphere%2C%20high%20detail&width=800&height=600&seq=gallery-hafen-01&orientation=landscape',
      alt: t('gallery.altHarbor'),
      span: '',
      height: 'h-[200px] md:h-[230px]',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Wadden%20sea%20mudflats%20at%20low%20tide%20with%20endless%20horizon%2C%20reflective%20wet%20sand%20patterns%2C%20dramatic%20cloudy%20sky%2C%20natural%20beige%20and%20gray%20tones%2C%20UNESCO%20world%20heritage%20landscape%20photography%2C%20vast%20serene%20atmosphere%2C%20high%20detail&width=800&height=600&seq=gallery-watt-01&orientation=landscape',
      alt: t('gallery.altNature'),
      span: 'md:col-span-2',
      height: 'h-[200px] md:h-[230px]',
    },
  ];

  return (
    <section id="gallery" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">
              {t('nav.gallery')}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3">
              {t('gallery.title')}
            </h2>
            <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
              {t('gallery.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[200px]">
            {images.map((img, idx) => (
              <button
                key={idx}
                onClick={() => setLightbox(img.src)}
                className={`relative overflow-hidden rounded-lg cursor-pointer group ${img.span} ${img.height}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <i className="ri-zoom-in-line text-white text-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 text-white/80 hover:text-white text-3xl cursor-pointer"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <i className="ri-close-line" />
          </button>
          <img
            src={lightbox}
            alt="Lightbox"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
          />
        </div>
      )}
    </section>
  );
}